<a href="https://github.com/sign/translate/issues" target="_blank">
  {{ 'settings.support.feedback.send' | transloco }}
</a>
